import React, { useState } from 'react';

import styled from 'styled-components';
//import MemberTable from '../common/MemberTable';
import { Ring } from 'react-awesome-spinners';
import Button from '../common/Button';
import { selectMainMembershipState, selectMainMembership, timeValueToDate, sort, sortReverse } from '../../lib/commonFunc/commonFunc'
import Select from 'react-select';
import palette from '../../lib/styles/palette';
import Pagination from '@material-ui/lab/Pagination';
import { GoSearch } from 'react-icons/go';
import { MdRefresh, MdSmartphone } from 'react-icons/md';

const MemberShipTilte = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-left: 5px;
    color: ${palette.webCyan[5]};
    font-size: 1.4rem;
  }
`;
const MemberBlock = styled.div`
  margin-top: 2.5rem;
`;
const ButtonBlock = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Filter = styled.div`
  display: flex;
  align-items: center;
`;
const TopMenu = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;
const MemberTable = styled.table`
  width: 100%;
  text-align: center;
  table-layout: fixed;
`
const MemberTableHeader = styled.thead`
  width: 100%;
  border-top: 1px solid ${palette.webGray[5]};
  border-bottom: 1px solid ${palette.webGray[5]};

  & tr{
    cursor: default;
    & td{
      font-weight: bold;
      padding: 12px 10px;
    }
  }
`

const MemberTableBody = styled.tbody`
  width: 100%;
  & tr {
    cursor: pointer;
    width: 100%;
    &:hover {
      background-color: ${palette.webGray[15]};
    }
  }
  
  & td {    
    font-size: .95rem;
    border-bottom: 1px solid ${palette.webGray[17]};
    text-overflow:ellipsis; 
    overflow:hidden; 
    white-space:nowrap;
  }
  
  & td:nth-child(1) {    
    color: ${palette.webCyan[5]};
  }
`
const BtnIcon = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: ${palette.webCyan[5]};
  color: #fff;
  font-size: 1.4rem;
  padding: 0 10px;
  border-radius: 5px;
  margin: 0 10px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

const ModalBlock = styled.div`
  width: 100%;
  height: 100%;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ModalBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`
const Modal = styled.form`
  position: relative;
  width: 180px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid ${palette.webGray[15]};
  border-radius: 5px;
  box-shadow: 0px 7px 7px 0px rgba(0,0,0, .2);
  z-index: 2;

  & input {
    width: 100%;
    padding: 7px 8px;
    box-sizing: border-box;
    font-size: .95rem;
    border: 1px solid ${palette.webGray[15]};
    border-radius: 5px;
    &:focus {
      outline: none;
    }
  }
  & input.warn {
    border: 1px solid rgba(240, 15, 15, .3);
  }
`
const ModalBtnBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  & button {
    width: 48%;
    font-size: .95rem;
    margin-top: 1rem;
    border-radius: 5px;
    background-color: ${palette.webCyan[5]};
    color: #fff;
    padding: 3px 0px;
    cursor: pointer;
    border: none;
    &:focus {
      outline: none;
    }
  }
  & button:nth-child(2) {
    background-color: ${palette.webGray[10]};
  }
`
const StateBox = styled.div`
  width: 100%;
  background-color: ${palette.valid};
  color: #fff;
  border-radius: 4px;
  padding: 3px  1px;
  text-overflow:ellipsis; 
  overflow:hidden; 
  white-space:nowrap;

  &.expiration {
  background-color: ${palette.expired};
  }
  &.holding {
  background-color: ${palette.hold};
  }
  &.waiting {
  background-color: ${palette.wait};
  }
`

// search part start 
const InputBlock = styled.div`
  display: flex;
`;
const StyledInput = styled.input`
  border : none;
  width: 100%;
  font-size: 1rem;
  padding-left: 1rem;
  
  &:focus {
    outline: none;
  }
`;
const StyledForm = styled.form`
  display: flex;
  align-items: center;
  border: 0.5px solid ${palette.webGray[4]};
  border-radius: 7px;

  & svg {
    cursor: pointer;
    color: ${palette.webCyan[5]};
    font-size: 1.5rem;
    margin: 0 12px;
  }
`;
// search part end


const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      width: state.selectProps.width,
      borderBottom: '1px dotted pink',
      color: state.selectProps.menuColor,
      padding: 20,
      fontSize: '0.95rem',
      'z-index': 500,
    }),
    indicatorSeparator: (provided, state) => ({
      backgroundColor: 'none',
    }),
    indicatorContainer: (provided, state) => ({
      color: '#e2feff',
    }),
    input: () => ({
      curosr: 'pointer',
    }),
    control: (_, { selectProps: { width } }) => ({
      width: width,
      display: 'flex',
      color: '#fff',
      'z-index': 500,
      curosr: 'pointer',
      border: '1px solid #ccc',
      fontSize: '0.95rem',
      paddingLeft: '10px',
      borderRadius: '5px'
    }),
    placeholder: () => ({
      cursor: 'pointer',
      color: '#e2feff',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    },
  };

const Line = styled.div`
  width: 100%;
  padding: 20px 10px;
  margin-bottom: 60px;
  border-bottom: 1px solid rgba(0, 0, 0, .1);
  padding-bottom: 60px;
`;

const PageWrapper = styled.div`
  margin-top: 24px;
  padding-bottom: 40px;
`;

const SectionWrapper = styled.div`
  margin-bottom: 24px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: visible;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
  border-radius: 12px 12px 0 0;
`;

const SectionTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
`;

const SectionBody = styled.div`
  padding: 24px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  & + & {
    margin-top: 18px;
  }
`;

const RowLabel = styled.div`
  width: 240px;
  flex-shrink: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #3a4656;

  span {
    color: #868e96;
    font-weight: 400;
  }
`;

const RowControl = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #555;
  font-size: 0.95rem;
`;

const StatusValue = styled.div`
  color: #555;
  font-size: 0.95rem;
`;

const TextInput = styled.input`
  border: 1px solid ${palette.inputBorder || '#CDD9ED'};
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.95rem;
  color: #2c3e50;
  transition: border-color 0.15s ease;

  &:focus {
    outline: none;
    border-color: ${palette.inputBorderFocus || '#275EFE'};
  }

  &::placeholder {
    color: #a5b1c3;
  }
`;

const OutlineButton = styled.button`
  border: 1px solid ${palette.webCyan[5]};
  background: #fff;
  color: ${palette.webCyan[5]};
  border-radius: 6px;
  padding: 8px 18px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: ${palette.webCyan[5]};
    color: #fff;
  }
`;

const PrimaryButton = styled.button`
  border: none;
  background: ${palette.webCyan[5]};
  color: #fff;
  border-radius: 6px;
  padding: 8px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '42px',
    width: '250px',
    borderColor: state.isFocused ? palette.webCyan[5] : (palette.inputBorder || '#CDD9ED'),
    borderRadius: '6px',
    boxShadow: 'none',
    fontSize: '0.95rem',
    '&:hover': {
      borderColor: palette.webCyan[5],
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 12px',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (provided) => ({
    ...provided,
    zIndex: 500,
    fontSize: '0.92rem',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#eef4ff' : '#fff',
    color: '#1f2933',
  }),
};

  const typeOptions = [
    { label: '법인', value: '6' },
    { label: '개인', value: '0' },
  ];

const bankOption = 
  [
    {label:"KDB산업은행", value:"002"},
    {label:"IBK기업은행", value:"003"},
    {label:"KB국민은행", value:"004"},
    {label:"수협은행", value:"007"},
    {label:"NH농협은행", value:"011"},
    {label:"농협중앙회(단위농축협)", value:"012"},
    {label:"우리은행", value:"020"},
    {label:"SC제일은행", value:"023"},
    {label:"한국씨티은행", value:"027"},
    {label:"대구은행", value:"031"},
    {label:"부산은행", value:"032"},
    {label:"광주은행", value:"034"},
    {label:"제주은행", value:"035"},
    {label:"전북은행", value:"037"},
    {label:"경남은행", value:"039"},
    {label:"새마을금고중앙회", value:"045"},
    {label:"신협중앙회", value:"048"},
    {label:"저축은행중앙회", value:"050"},
    {label:"산림조합중앙회", value:"064"},
    {label:"우체국", value:"071"},
    {label:"하나은행", value:"081"},
    {label:"신한은행", value:"088"},
    {label:"케이뱅크", value:"089"},
    {label:"카카오뱅크", value:"090"},
	{label:"토스뱅크", value:"092"},
    {label:"KB증권", value:"218"},
    {label:"미래에셋대우", value:"238"},
    {label:"삼성증권", value:"240"},
    {label:"한국투자증권", value:"243"},
    {label:"NH투자증권", value:"247"},
    {label:"교보증권", value:"261"},
    {label:"하이투자증권", value:"262"},
    {label:"현대차증권", value:"263"},
    {label:"키움증권", value:"264"},
    {label:"이베스트투자증권", value:"265"},
    {label:"SK증권", value:"266"},
    {label:"대신증권", value:"267"},
    {label:"한화투자증권", value:"269"},
    {label:"신한금융투자", value:"278"},
    {label:"DB금융투자", value:"279"},
    {label:"유진투자증권", value:"280"},
    {label:"메리츠증권", value:"287"},
  ]

const AdminClubMobileAuth = ({
    onChangeSelect,
    type,
    onChangeSelectBankType,
    bankType,
    clubOptions,
    clubType,
    onChangeSelectClub,
    setCompanyNumber,
    setBankAccount,
    setBankAccountName,
    companyNumber,
    accountAuth,
    salesState,
    bankAccount,
    bankAccountName,
    onClickAuth,
    onClickStateChangeClub,
    fee,
    setFee,
    onSaveFee
}) => {

  return (
    <PageWrapper>
        <SectionWrapper>
            <SectionBody>
                <Row>
                    <RowLabel>클럽 선택</RowLabel>
                    <RowControl>
                        <Select
                            options={clubOptions}
                            onChange={onChangeSelectClub}
                            placeholder="클럽 선택"
                            styles={selectStyles}
                            isSearchable={false}
                            aria-labelledby="select"
                            value={{label: clubOptions.find(item => item.value === clubType) != null?clubOptions.find(item => item.value === clubType).label:'', value: clubType}}
                            width="250px"
                        />
                    </RowControl>
                </Row>
                <Row>
                    <RowLabel>모바일 판매 상태</RowLabel>
                    <RowControl>
                        <StatusValue>{salesState == 2?'판매 일시 중지':(salesState == 0?'판매 안함':(salesState == 1?'판매 중':'-'))}</StatusValue>
                    </RowControl>
                    <OutlineButton onClick={() => onClickStateChangeClub()}>
                        상태 전환
                    </OutlineButton>
                </Row>
            </SectionBody>
        </SectionWrapper>

        <SectionWrapper>
            <SectionHeader>
                <SectionTitle>계좌 인증</SectionTitle>
            </SectionHeader>
            <SectionBody>
                <Row>
                    <RowLabel>계좌 종류</RowLabel>
                    <RowControl>
                        <Select
                            options={typeOptions}
                            onChange={onChangeSelect}
                            placeholder="계좌 종류"
                            styles={selectStyles}
                            isSearchable={false}
                            aria-labelledby="select"
                            value={{label: typeOptions.find(item => item.value === type) != null?typeOptions.find(item => item.value === type).label:'', value: type}}
                            width="250px"
                            defaultValue={typeOptions[0]}
                        />
                    </RowControl>
                </Row>
                <Row>
                    <RowLabel>{type==0?'셩년월일(821111)':'사업자번호'}</RowLabel>
                    <RowControl><TextInput value={companyNumber} onChange={(e) => setCompanyNumber(e.target.value)} style={{width: '250px'}} type="text"/></RowControl>
                </Row>
                <Row>
                    <RowLabel>계좌번호 <span style={{fontSize: '.9rem'}}>(정산 받을 계좌)</span></RowLabel>
                    <RowControl>
                        <Select
                            options={bankOption}
                            onChange={onChangeSelectBankType}
                            placeholder="은행 선택"
                            styles={selectStyles}
                            isSearchable={false}
                            aria-labelledby="select"
                            value={{label: bankOption.find(item => item.value === bankType) != null?bankOption.find(item => item.value === bankType).label:'', value: bankType}}
                            width="250px"
                            defaultValue={bankOption[0]}
                        />
                        <TextInput placeholder="계좌번호" value={bankAccount} onChange={(e) => setBankAccount(e.target.value)} style={{width: '300px'}} type="text"/>
                        <TextInput placeholder="예금주" value={bankAccountName} onChange={(e) => setBankAccountName(e.target.value)} style={{width: '180px'}} type="text"/>
                    </RowControl>
                </Row>
                <Row>
                    <RowLabel>{'계좌 인증 상태'}</RowLabel>
                    <RowControl><StatusValue>{accountAuth == 1?'인증 완료':'미 인증'}</StatusValue></RowControl>
                </Row>
                <ButtonRow>
                    <OutlineButton onClick={() => onClickAuth()}>
                        인증 받기
                    </OutlineButton>
                </ButtonRow>
            </SectionBody>
        </SectionWrapper>

        <SectionWrapper>
            <SectionHeader>
                <SectionTitle>수수료 설정</SectionTitle>
            </SectionHeader>
            <SectionBody>
                <Row>
                    <RowLabel>수수료 <span style={{fontSize: '.9rem'}}>(%)</span></RowLabel>
                    <RowControl>
                        <TextInput
                            value={fee !== null && fee !== undefined ? fee : ''}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9.]/g, '');
                                // 소수점이 여러 개인 경우 제거
                                const parts = value.split('.');
                                const cleanValue = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : value;

                                if (cleanValue === '' || (!isNaN(cleanValue) && parseFloat(cleanValue) >= 0 && parseFloat(cleanValue) <= 100)) {
                                    setFee(cleanValue === '' ? null : cleanValue);
                                }
                            }}
                            placeholder="수수료를 입력하세요 (예: 4.5)"
                            style={{width: '250px'}}
                            type="text"
                        />
                        <span style={{fontSize: '.95rem', color: '#868e96'}}>%</span>
                        <PrimaryButton
                            onClick={() => onSaveFee()}
                        >
                            저장
                        </PrimaryButton>
                    </RowControl>
                </Row>
            </SectionBody>
        </SectionWrapper>
    </PageWrapper>
  );
};

export default React.memo(AdminClubMobileAuth);
